import * as React from "react";
import * as Loadable from "react-loadable";
import { Loader } from "src/common/components";

export const CycleParticipantsPage = Loadable({
  loader: () => import("../containers/CycleParticipantsPage"),
  loading: () => <Loader />
});
